import { CategoryMultiValuedList } from '../../../Category/'
import { ListCell } from '../ListCell'
import { TableTextCell } from '../TableTextCell'

function TableCategoryListCell({
  apiParams,
  getLabel,
  isSingleValue,
  scrollRef,
  value,
  ...cellProps
}) {
  const preparedValue = value
    ? [
        { children: getLabel(value) },
        ...Array.from({ length: value.count - 1 }),
      ]
    : null

  return isSingleValue || !value ? (
    <TableTextCell {...cellProps} value={getLabel(value)} />
  ) : (
    <ListCell
      {...cellProps}
      List={CategoryMultiValuedList}
      count={value?.count}
      listProps={{ apiParams }}
      scrollRef={scrollRef}
      value={preparedValue}
    />
  )
}

export default TableCategoryListCell
